
import React from 'react';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { ManagerInvite } from '@/types/userRole';
import { formatDistanceToNow } from 'date-fns';
import { Clock, XCircle } from 'lucide-react';

interface PendingInvitesTableProps {
  invites: ManagerInvite[];
  onCancel: (inviteId: string) => Promise<void>;
}

const PendingInvitesTable: React.FC<PendingInvitesTableProps> = ({ invites, onCancel }) => {
  return (
    <div className="rounded-md border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Sent</TableHead>
            <TableHead>Expires</TableHead>
            <TableHead className="w-[80px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invites.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-8 text-muted-foreground">
                No pending invitations
              </TableCell>
            </TableRow>
          ) : (
            invites.map((invite) => (
              <TableRow key={invite.id}>
                <TableCell className="font-medium">{invite.name}</TableCell>
                <TableCell>{invite.email}</TableCell>
                <TableCell>{formatDistanceToNow(new Date(invite.createdAt))} ago</TableCell>
                <TableCell>
                  <span className="flex items-center">
                    <Clock className="h-4 w-4 mr-1 text-amber-500" />
                    {formatDistanceToNow(new Date(invite.expiresAt))}
                  </span>
                </TableCell>
                <TableCell>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onCancel(invite.id)}
                    className="text-destructive hover:text-destructive"
                  >
                    <XCircle className="h-4 w-4" />
                    <span className="sr-only">Cancel</span>
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default PendingInvitesTable;
